<template>
  <button
    class="back_button flex-row flex-start"
    @click="handleClick"
    aria-label="返回"
  >
    <img
      class="back_icon"
      :src="
        require('@/assets/components/FigmaDDSSlicePNGb57ad1c423c2e4019b8e6ba78413c80e.png')
      "
      alt="Back arrow"
    />
    <span class="back_text">{{ props.text }}</span>
  </button>
</template>

<script setup>
import { defineProps } from "vue"
import { useRouter } from "vue-router"
const router = useRouter()

const props = defineProps({
  customClick: {
    type: Function,
    required: false,
    default: null,
  },
  text: {
    type: String,
    default: "返回",
  },
})

const handleClick = () => {
  if (props.customClick) {
    props.customClick()
  } else {
    router.back()
  }
}
</script>

<style scoped>
.back_button {
  width: auto;
  height: 1.67vw;
  cursor: pointer;
  background-color: transparent;
}

.back_button:hover {
  opacity: 0.8;
}

.back_icon {
  width: 1.25vw;
  height: 1.25vw;
  margin-top: 0.28vw;
  margin-right: 0.3vw;
}

.back_text {
  width: auto;
  height: 1.67vw;
  font-size: 1.25vw;
  line-height: 1.67vw;
  color: rgba(55, 91, 165, 1);
  font-family: Microsoft YaHei-Regular;
}
</style>
